import React from "react";

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

import JobLiveTableViewRow from "./JobLiveTableViewRow";
import { EmptyState, TableLoading } from "../../../common";

const JobLiveTableView = ({
  tableData,
  totalPosts,
  page,
  setPage,
  rowsPerPage,
  onRowsPerPageChange,
  isLoading,
}) => {
  const isEmpty = tableData ? tableData?.length === 0 : false;

  return (
    <Card
      sx={{ px: 2, pt: 1, width: "97%", borderTop: 1, borderColor: "#E9EBF0" }}
    >
      <TableContainer
        sx={{
          overflow: "auto",
          borderColor: "#CFCFCF",
          width: "100%",
          borderRadius: "8px",
          maxWidth: "100%",
          "& .MuiTableRow-root:hover": { backgroundColor: "primary.200" },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns?.map((column) => (
                <TableCell
                  key={column.id}
                  align="left"
                  sx={{ bgcolor: "#f3f4f6" }}
                >
                  <Typography
                    fontSize={"15px"}
                    fontWeight={600}
                    color="#21282F"
                  >
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableLoading noOfColumns={8} />
            ) : (
              tableData?.map((id) => <JobLiveTableViewRow key={id} id={id} />)
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isEmpty && !isLoading && (
        <EmptyState
          title="Looks like there's no jobs found. Try adjusting your filters"
          top={"10%"}
          sx={{ my: 5 }}
        />
      )}
      {tableData?.length > 0 && (
        <TablePagination
          component="div"
          count={totalPosts}
          page={page - 1}
          onPageChange={(_, newPage) => setPage(newPage + 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          sx={{
            fontFamily: "Outfit",
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                fontFamily: "Outfit",
              },
            "& .MuiInputBase-root": {
              fontFamily: "Outfit",
            },
          }}
        />
      )}
    </Card>
  );
};

const columns = [
  { id: "name", label: "Job Details" },
  { id: "posted_on", label: "Stage" },
  { id: "status", label: "Type" },
  { id: "cv_received", label: "Candidates" },
  { id: "passed_candidates", label: "Passed Candidates" },
  { id: "cv_parsed", label: "Dates" },
  { id: "expiry_date", label: "Criteria" },
  { id: "created_by", label: "Created By" },
  { id: "action", label: "Actions" },
];

export default JobLiveTableView;
